import { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { SeasonNoticeAndNewsletter } from "../components/SeasonNoticeAndNewsletter";

const Newsletter = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <>
      <div className="bg-white">
        {/* Hero Section */}
        <div className="relative w-full h-[280px] lg:h-[33vw] overflow-hidden">
          <img
            src="/images/alian.jpg"
            alt="Composers Hero"
            className="w-full h-full object-cover object-[80%_-185%] md:object-[50%_-15%] sm:object-[50%_5%]"
            onLoad={() => setImageLoaded(true)}
          />
          {imageLoaded && (
            <div className="absolute mt-20 md:mt-40 inset-0 flex flex-col items-center justify-center p-4 text-center">
              <h1
                className="text-2xl md:text-5xl lg:text-7xl mb-2 text-white font-cormorant-garamond font-medium"
                style={{
                  textShadow: "1.5px 2px  rgba(0,0,0)",
                }}
              >
                Never miss the best again
              </h1>
            </div>
          )}
        </div>
        {/* Breadcrumb */}
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "Newsletter", href: "/newsletter" },
          ]}
        />
        {/* Main Content */}
        <main
          className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
          aria-label="Site Notice"
        >
          <div className="flex gap-10 mb-5">
            <div>
              <h1 className="text-4xl md:text-3xl text-opera-red mb-4">
                Newsletter
              </h1>
              <div className="text-gray-700 text-lg text-justify flex flex-col gap-3">
                <p className="font-semibold">Dear Opera Lovers! </p>
                <p>
                  The OperaToday.org newsletter is aimed at everyone who wants
                  to learn more about the most beautiful opera performances,
                  outstanding artists, and the world’s most renowned opera
                  houses, such as those in Vienna, Milan, or Paris.
                </p>
                <p>
                  Our program is constantly expanding—so visit us again soon or
                  subscribe to the OperaToday.org newsletter free of charge and
                  without obligation. You can unsubscribe from the newsletter at
                  any time with each issue.
                </p>
                <div>
                  <p>
                    Wishing you an enjoyable time planning your opera journey,
                  </p>
                  <p className="-mt-1">Your OperaToday.org Team</p>
                </div>
              </div>
            </div>
          </div>
          <div className="-ml-1">
            <SeasonNoticeAndNewsletter newsletterPage={true} />
          </div>
        </main>
      </div>
    </>
  );
};
export default Newsletter;
